module.exports = __webpack_public_path__ + "static/media/tutoring-welcome.efc0331b.svg";